import {MailOutlined} from '@ant-design/icons';
import {Button, Divider, Space} from 'antd';
import React, {memo, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useQueryClient} from 'react-query';

import {DIALOG_NAMESPACE} from '@/components/NewEmailDialog';
import {useDialogsContext} from '@/contexts/DialogsContext';
import UserDeleteManyButton from '@/modules/admin/components/UserDeleteManyButton';
import UserStatusSelect from '@/modules/admin/components/UserStatusSelect';
import {useUserList} from '@/modules/admin/containers/UserEntityContainer';

// eslint-disable-next-line react/prop-types
const UserSelectionAction = ({selectedRows, selectedRowKeys}) => {
  const queryClient = useQueryClient();
  const {openDialog: showEmail} = useDialogsContext(DIALOG_NAMESPACE);
  const {t} = useTranslation('admin');
  const {activeKey} = useUserList();
  
  const sendMail = useCallback(() => {
    showEmail({users: selectedRows});
  }, [selectedRows, showEmail]);
  
  const handleChange = useCallback(() => {
    queryClient.invalidateQueries(activeKey);
  }, [activeKey, queryClient]);
  
  return (
    <Space size={0}>
      <Divider size={'small'} type="vertical"/>
      <UserStatusSelect users={selectedRowKeys} onChange={handleChange}/>
      <Button size={'small'} onClick={sendMail} type="link" icon={<MailOutlined/>}>{t('sendEmail')}</Button>
      <Divider size={'small'} type="vertical"/>
      <UserDeleteManyButton users={selectedRowKeys} onDelete={handleChange}/>
    </Space>
  );
};

export default memo(UserSelectionAction);
